export default "__VITE_ASSET__BlBNXQ_O__"